import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DiaryRepository } from '../../data/tracker/repositories/diary_repository';
import { TrackerRepository } from '../../data/tracker/repositories/tracker_repository';
import { ConditionedTabAlertComponent } from './components/conditioned-tab-alert/conditioned-tab-alert.component';
import { SidebarModule } from './components/sidebar/sidebar.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardService } from './dashboard.service';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { AccountModule } from './routes/account/account.module';
import { CustomTrackersModule } from './routes/custom-trackers/custom-trackers.module';
import { PatientGroupsModule } from './routes/patient-groups/patient-groups.module';
import { QuestionsModule } from './routes/questions/questions.module';
import { QuestionsService } from './routes/questions/questions.service';
import { PatientListService } from './routes/questions/routes/patients-list/patient-list.service';

@NgModule({
  declarations: [DashboardComponent, ConditionedTabAlertComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SidebarModule,
    QuestionsModule,
    PatientGroupsModule,
    AccountModule,
    CustomTrackersModule,
  ],
  providers: [
    QuestionsService,
    DashboardService,
    PatientListService,
    DiaryRepository,
    TrackerRepository,
    PatientListService,
  ],
})
export class DashboardModule {}
